import React from 'react';
import DNDTable from 'components/lib/tables/dnd/DNDTable';
import DNDTotalHeader from 'components/lib/tables/dnd/DnDTotalHeader';
import { CalendarBtn, NoData } from 'components/lib/buttons/IconButtons';
import DatePicker from 'material-ui/DatePicker';
import { Tabs, Tab } from 'material-ui/Tabs';
import SwipeableViews from 'react-swipeable-views';
import styles from 'styles/components/series/tbContainer.css'

let COLUMNS = [
  { selector: true,
    name: 'selector',
    grow: 0,
    width: 40
  },
  { title: "Ticket Type",
    name: "name",
    accessor: data => {
      return !!data.children ? <p>{data.name}</p>
      : <p>{data.displayName}</p> },
    grow: 3,
    sortBy: "key",
    width: 165
  },
  { title: "Promotion",
    name: "promotionName",
    accessor: "promotionName",
    grow: 1,
    sortBy: "promotionName",
    width: 120
  },
  { title: "Price Level/Section",
    name: "priceLevelSection",
    accessor: "priceLevelSection",
    grow: 2,
    sortBy: "priceLevelSection",
    width: 175
  },
  { title: "Quantity",
    name: "quantity",
    accessor: "numTicketsSold",
    grow: 1,
    sortBy: "numTicketsSold",
    width: 90
  },
  { title: "Revenue",
    name: "total",
    accessor: "totalRevenue",
    grow: 1,
    sortBy: "totalRevenue",
    width: 90
  },
  { title: "Actions",
    name: "actions",
    actions: data => {
      return !!data.children ? ['Edit', 'Ungroup', 'Expand']
      : ['Delete', 'AddTo'] },
    grow: 0,
    width: 120
  }
];

let BUCKET_TYPE = {
  name: "",
  color: '0000FF',
  childrenKeys: []
};

/*
accessor: "data => {"
  return !!data.children ? data.totalAmount
  : data.ticketPrice * data.numTicketsSold },
*/

export default class TBContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      packageBuckets: this.props.data && this.props.data.packageBuckets,
      packageTickets: this.props.data && this.props.data.packageTickets,
      ticketBuckets: this.props.data && this.props.data.ticketBuckets,
      tickets: this.props.data && this.props.data.tickets,
      controlledDate: this.props.settings.controlledDnDTableDate,
      slideIndex: 0,
      productionChange: false,
      totals: {
        ticketTotals: {qty: 0, revenue: 0},
        packageTicketTotals: {qty: 0, revenue: 0}
      }
    };
  }

  componentDidMount() {
    this.refs.title.focus();
    // let ticketElem = document.getElementById("ticketsTab");
    // let packageElem = document.getElementById("packagesTab");
    // if (ticketElem) {
    //   ticketElem.addEventListener("mouseover", () => {
    //     if(this.state.slideIndex === 1) {
    //       let event;
    //       if(typeof(Event) === 'function') {
    //         event = new Event('closeEdit');
    //       } else {
    //         event = document.createEvent('Event');
    //         event.initEvent('closeEdit', true, true);
    //       }
    //       window.dispatchEvent(event);
    //     }
    //   })
    // }
    // if (packageElem) {
    //   packageElem.addEventListener("mouseover", () => {
    //     if(this.state.slideIndex === 0) {
    //       let event;
    //       if(typeof(Event) === 'function') {
    //         event = new Event('closeEdit');
    //       } else {
    //         event = document.createEvent('Event');
    //         event.initEvent('closeEdit', true, true);
    //       }
    //       window.dispatchEvent(event);
    //     }
    //   })
    // }
  }
  componentWillReceiveProps(nProps) {
    if (nProps.settings && nProps.settings.controlledDnDTableDate){
      this.setState({
        controlledDate: nProps.settings.controlledDnDTableDate
      })
    }
    if (nProps.productionId !== this.state.productionId) this.setState({ productionChange: true })
    if (nProps.data && (this.state.productionChange ||
        !Object.deepEquals(nProps.data, this.props.data))) {
      if(this.state.slideIndex === 0) this.handleTabChange();
      else if(this.state.slideIndex === 1) this.handleTabChange(1);
      this.setState({
        packageBuckets: nProps.data.packageBuckets,
        packageTickets: nProps.data.packageTickets,
        ticketBuckets: nProps.data.ticketBuckets,
        tickets: nProps.data.tickets,
        productionChange: false
      }, () => {
        this.getTotals();
      })
    }
  }
  getDateObject = (date) => {
    return date.toDateString().substring(4, 15);
  }
  getDeepClone = (obj) => {
    return JSON.parse(JSON.stringify(obj));
  }
  getTotals = () => {
    let { tickets, packageTickets } = this.state;
    let ticketTotals = {qty: 0, revenue: 0}, packageTicketTotals = {qty: 0, revenue: 0};
    for (let key in tickets) {
      ticketTotals.qty += tickets[key].numTicketsSold;
      ticketTotals.revenue += tickets[key].totalRevenue;
    }
    for (let keyTwo in packageTickets) {
      packageTicketTotals.qty += packageTickets[keyTwo].numTicketsSold;
      packageTicketTotals.revenue += packageTickets[keyTwo].totalRevenue;
    }
    console.log("GETTINGTOTALS", {
      ticketTotals: ticketTotals,
      packageTicketTotals: packageTicketTotals
    });

    this.setState({
      totals: { ticketTotals: ticketTotals, packageTicketTotals: packageTicketTotals }
    })
  }
  handleDateChange = (e, date) => {
    let event;
    if(typeof(Event) === 'function') {
      event = new Event('closeEdit');
    } else {
      event = document.createEvent('Event');
      event.initEvent('closeEdit', true, true);
    }
    window.dispatchEvent(event);
    if(date !== this.state.controlledDate) {
      this.setState({
        controlledDate: date
      }, () => {
        this.props.onSettingsChange({controlledDnDTableDate: date})
      });
    }
  }
  handleDeleteBucket = (key, isPackageTable) => {
    let buckets = this.getDeepClone(isPackageTable ? this.state.packageBuckets : this.state.ticketBuckets);
    delete buckets[key];
    this.props.onBucketDelete(key);
    if (isPackageTable) this.setState({ packageBuckets: buckets })
    else this.setState({ ticketBuckets: buckets });
  }
  handleEditBucket = (key, details, isPackageTable) => {console.log('HANDLEEDITBUKET', key, details);
    let buckets = this.getDeepClone(isPackageTable ? this.state.packageBuckets : this.state.ticketBuckets);
    let editedBucket = Object.assign({}, buckets[key], details);
    buckets[key] = editedBucket;
    this.props.onBucketUpdate(key, editedBucket);
    if (isPackageTable) this.setState({ packageBuckets: buckets });
    else this.setState({ ticketBuckets: buckets });
  }
  handleNewBucket = (bucket, isPackageTable) => {
    let buckets = this.getDeepClone(isPackageTable ? this.state.packageBuckets : this.state.ticketBuckets);

    if (isPackageTable) {
      this.props.onBucketAdd(Object.assign({}, bucket, {type: 'PACKAGE'}));
      // this.setState({ packageBuckets: buckets })
    } else {
      this.props.onBucketAdd(Object.assign({}, bucket, {type: 'TICKET'}));
      // this.setState({ ticketBuckets: buckets })
    }
  }
  handleTabChange = (value = 0) => {
    if (value <= 1) this.setState({ slideIndex: value });
    if (this.state.slideIndex !== value) {
      let event;
      if (typeof(Event) === 'function') {
        event = new Event('closeEdit');
      } else {
        event = document.createEvent('Event');
        event.initEvent('closeEdit', true, true);
      }
      window.dispatchEvent(event);
    }
  }
  prepareRows = (data) =>{
    let newData = Object.assign({}, data);
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
      let keyToAttach = keys[i];
      newData[keyToAttach].key = keyToAttach
    }
    return newData;
  }

  render() {
    let { minDate, maxDate } = this.props.settings;
    let { slideIndex, tickets, ticketBuckets, packageTickets, packageBuckets } = this.state;
    let displayDate = this.state.controlledDate ? this.getDateObject(this.state.controlledDate) : null;
    let hasTicketData = tickets && Object.keys(tickets).length > 0;
    let hasPackageData = packageTickets && Object.keys(packageTickets).length > 0;
    return (
      <section id="dailyReportBuilder" className={styles.tbContainer} style={{minHeight: '90vh', margin: '40px 0', width: '100%'}}>
        <DNDTotalHeader
          hasData={this.state.slideIndex === 0 ? hasTicketData : hasPackageData}
          ticketData={this.state.totals.ticketTotals}
          packageData={this.state.totals.packageTicketTotals}
          data={this.state.slideIndex === 0 ? this.state.totals.ticketTotals : this.state.totals.packageTicketTotals} />
        <h1 ref="title" className={styles.printHidden} style={{marginBottom: '40px'}}>Daily Report Builder</h1>
        <header className={styles.header}>
          <nav id="navigation" className={styles.nav}>
            <Tabs className={styles.tabContainer}
                  onChange={this.handleTabChange}
                  value={this.state.slideIndex}
                  tabItemContainerStyle={{backgroundColor: 'transparent'}}>
              <Tab id="ticketsTab" label="Ticket Types"
                   onClick={()=> {console.log("HERE")}}
                   style={{color: slideIndex === 0 ? '#3395FF' : '#CCCCCC'}}
                   value={0} />
              <Tab id="packagesTab" label="Packages"
                   onClick={()=> {console.log("HERE")}}
                   style={{color: slideIndex === 1 ? '#3395FF' : '#CCCCCC'}}
                   value={1} />
            </Tabs>
          </nav>
          <div className={styles.extraLine}></div>
          { this.props.hasSalesData &&
            <DatePicker
              className={styles.datePicker}
              container={(this.props.isTouchDevice) ? "" : "inline"}
              firstDayOfWeek={0}
              formatDate={this.getDateObject}
              minDate={minDate}
              maxDate={maxDate}
              onChange={this.handleDateChange}
              textFieldStyle={{width: '170px'}}
              value={this.state.controlledDate}
            >
              <CalendarBtn className={styles.datePickerButton} date={displayDate}/>
            </DatePicker>
          }
        </header>
        <SwipeableViews className={styles.tbContainerSwipe} disabled={true} index={this.state.slideIndex}>
          {!hasTicketData ? (
            <div className={styles.printHidden}>
              <NoData/>
            </div>
          ) : (
            <DNDTable ref="ticketTypesTable"
                      accessor="ticketTypeKey"
                      buckets={this.state.ticketBuckets}
                      bucketsAccomulatives={['numTicketsSold', 'totalRevenue']}
                      bucketsEditables={['name', 'color']}
                      bucketType={BUCKET_TYPE}
                      clearError={this.props.clearError}
                      columns={COLUMNS}
                      data={this.prepareRows(this.state.tickets)}
                      errorBucketKey={this.props.errorBucketKey}
                      errorMessage={this.props.errorMessage}
                      isActive={slideIndex === 0}
                      onCreateNewBucket={this.handleNewBucket}
                      onDeleteBucket={this.handleDeleteBucket}
                      onEditBucket={this.handleEditBucket}
                      productionId={this.props.productionId}
                      sortValue={this.state.sortValue} />
          )}
          {!hasPackageData ? (
            <div className={styles.printHidden}>
              <NoData/>
            </div>
          ) : (
            <DNDTable ref="packagesTable"
                      accessor="ticketTypeKey"
                      buckets={this.state.packageBuckets}
                      bucketsAccomulatives={['numTicketsSold', 'totalRevenue']}
                      bucketsEditables={['name', 'color']}
                      bucketType={BUCKET_TYPE}
                      clearError={this.props.clearError}
                      columns={COLUMNS}
                      data={this.prepareRows(this.state.packageTickets)}
                      errorBucketKey={this.props.errorBucketKey}
                      errorMessage={this.props.errorMessage}
                      isActive={slideIndex === 1}
                      onCreateNewBucket={this.handleNewBucket}
                      onDeleteBucket={this.handleDeleteBucket}
                      onEditBucket={this.handleEditBucket}
                      productionId={this.props.productionId}
                      packages={true}
                      sortValue={this.state.sortValue} />
          )}
        </SwipeableViews>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/ticketBreakdown/TBContainer.js